import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
const ROUTES = [];

const routeModules = require.context('.', true, /\.js$/);
routeModules.keys().forEach((fileName) => {
  if (fileName === './index.js') return;
  const routes = routeModules(fileName).default;
  routes.forEach((route) => generateRoute(route));
});

function syncParentMeta(meta, parentMeta) {
  let parentMiddleWares = parentMeta.middleware;
  let parentLayout = parentMeta.layout;
  if (parentMiddleWares) {
    meta.middleware = meta.middleware || [];
    parentMiddleWares = Array.isArray(parentMiddleWares)
      ? parentMiddleWares
      : [parentMiddleWares];
    meta.middleware = Array.from(
      new Set([...parentMiddleWares, ...meta.middleware])
    );
    if (!meta.middleware.length) {
      delete meta.middleware;
    }
  }
  meta.layout = meta.layout || parentLayout || '';
  if (!meta.role && parentMeta.role) {
    meta.role = parentMeta.role;
  }
}

function parseRoute(
  { url, page, name, meta = {}, group = [], children = [] },
  parentMeta = {}
) {
  syncParentMeta(meta, parentMeta);
  let route = {
    name: name || view,
    path: url,
    component: () => import(`@pages/${page}.vue`),
    meta,
    group,
  };
  if (children.length) {
    route.children = children.map((route) => parseRoute(route, meta));
  }

  return route;
}

function generateRoute(route, parentMeta = {}) {
  route = parseRoute(route, parentMeta);
  ROUTES.push(route);
  let group = route.group || [];
  if (group.length) {
    group.forEach((groupRoute) => {
      if (!groupRoute.url.startsWith('/')) {
        if (!route.path.endsWith('/')) {
          route.path = route.path + '/';
        }
        groupRoute.url = route.path + groupRoute.url;
      }
      generateRoute(groupRoute, route.meta || {});
    });
  }
}

Vue.use(Router);

// Create a new router
const router = new Router({
  mode: 'history',
  routes: ROUTES.concat([
    {
      path: '*',
      meta: {
        layout: 'Error',
        code: 404,
      },
    },
  ]),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

// Reference: https://markus.oberlehner.net/blog/implementing-a-simple-middleware-with-vue-router/
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach(async (to, from, next) => {
  const isOnline = navigator?.onLine ?? true;

  if (!isOnline) {
    if (
      !['offline-trips', 'new-offline-trip', 'edit-offline-trip'].includes(
        to.name
      )
    ) {
      await router.push({ name: 'offline-trips' });
    }
  }

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);
    if (!middleware.length) {
      next();
      return;
    }
    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

Vue.use(Meta, {
  refreshOnceOnNavigation: true,
});

export default router;
